// composables/useAnalytics.ts
export function useAnalytics() {
  const trackEvent = (eventName: string, eventData = {}) => {
    if (process.client && window.umami) {
      window.umami.track(eventName, eventData)
    }
  }
  
  return {
    trackEvent
  }
}